var React = require('react');

function Reminder2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 0h12a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm1.5 2a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-9zm7.563 1.765a.806.806 0 0 1 1.191-.003.921.921 0 0 1 .003 1.25L6.37 10.244a.81.81 0 0 1-.595.256c-.211 0-.398-.086-.575-.247L2.763 7.809a.922.922 0 0 1-.035-1.253.803.803 0 0 1 1.181-.033L5.765 8.38l4.298-4.616z","fill":"#424242","fillRule":"evenodd"}));
}

Reminder2.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14"};

module.exports = Reminder2;

Reminder2.default = Reminder2;
